import { Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import xlsx from '../images/xlsx.png';
import pdf from '../images/pdf.png';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { utils, writeFile } from 'xlsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
	borderColor,
	buttonStyles,
	button_Styles1,
	csvStyle,
	filterSectionStyle,
	grid_Button_Style,
	grid_Icon_Style,
	headerSection,
	pdfStyle,
	textStyling,
	titleWithTextfield,
	headerStyling,
} from './GeneralStyles';

import {
	getChargesReport,
	getVisit,
	getPracticeStaff,
	getAlllocations,
	getLocation,
	postVisitDatalist,
} from '../../../../app/services/api/apiManager';
import PatientReport from '../PatientReport';
import dayjs from 'dayjs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CircularProgress from '@mui/material/CircularProgress';

// Dispatch Section
// import { useStateValue } from '../../../services/state/State';
// import { actions } from '../../../services/state/Reducer';

const PVS = () => {
	// *****	Using Dispatch States	*****

	// const [{practice,practicestats,batches,locations,visits,providers},dispatch] = useStateValue();
	// console.log("location get data", locations);
	// console.log("Providers get data", providers);
	// console.log("Visits get data", visits);

	// const showPracticeData = async () => {
	// 		const response = await getPracticeStaff();
	// 		if(response?.status === 200){
	// 			dispatch({ type: actions.SET_PROVIDERS, payload: response?.data});
	// 		} else dispatch({ type: actions.SET_PROVIDERS, payload: []});
	// }

	// Loader State
	const [isLoading, setIsLoading] = useState(true);

	// Get Practice ID with Local Storage
	const practiceID = localStorage.getItem('practice_id');

	// Navigate to Page State
	const [currentPage, setCurrentPage] = useState(true);

	// All Api Data State
	const [allLocations, setAllLocations] = useState([]);
	const [allProviders, setAllProviders] = useState([]);
	const [allVisits, setAllVisits] = useState([]);

	// Filter Data
	const [filterData, setFilterData] = useState([]);

	// Export Data State
	const [exportData, setExportData] = useState(true);

	const [pdfUrl, setPdfUrl] = useState('');

	// Handle Date Value States
	const [dateValue, setDateValue] = useState({
		fromDate: dayjs().startOf('month'),
		toDate: dayjs(),
	});

	// Formate date
	const formatFromDate = dayjs(dateValue.fromDate).format('YYYY-MM-DD');
	const formatToDate = dayjs(dateValue.toDate).format('YYYY-MM-DD');

	// Target Date Value Function
	const handleDateValue = (name, date) => {
		setDateValue({
			...dateValue,
			[name]: date,
		});
		getVisitListData(filtersData);
	};

	// Handle Select Value States
	const [selectValue, setSelectValue] = useState({
		location: '',
		provider: '',
	});

	// Target Select Value Function
	const handleSelectValue = (event) => {
		setSelectValue({
			...selectValue,
			[event.target.name]: event.target.value,
		});
		getVisitListData(filtersData);
	};

	// Reset All Values
	const resetValues = () => {
		setSelectValue({
			location: '',
			provider: '',
		});
		setDateValue({
			fromDate: '',
			toDate: '',
		});

		setExportData(true);
		setFilterData([]); // Show text when Data is Empty
		getVisitListData({ practice_id: practiceID, in_VisitStatus: 'A' }); // get all Data, after Resting Textfields
	};

	// Define table styles
	const styles = {
		cellPadding: 2,
		fontSize: 12,
		halign: 'center',
		valign: 'middle',
		// fillColor: '#EEEEEE', // Background color of table cells
		// textColor: '#000000', // Text color of table cells
		fontStyle: 'normal', // Font style of table cells
		// overflow: 'ellipsize', // How to handle overflowing content
		lineWidth: 0.1, // Width of table borders
		lineColor: '#000000', // Color of table borders
	};

	// Download Pdf File with All Data

	const downloadAllData = () => {
		// const approvedStatus = allVisits?.filter((item) => {
		// 	return item.VisitStatus == 'A';
		// });

		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Approved Visit History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Approved Visit History', xPos, 15);

		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');

		doc.autoTable({
			startY: 20,
			head: [
				[
					// Colmn Fields Name here
					'Serial No.',
					'Patient',
					'Gender',
					'Provider',
					'Location',
					'Visit Status',
					'Visit Date',
				],
			],
			body: allVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ', ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.provider === ', ' ? '' : item?.provider,
				item?.location != null || item?.location != '' ? item?.location : '',
				item?.VisitStatus == 'A' ? 'Approved' : '',
				dayjs(item?.VisitDate).format('DD-MM-YYYY'),
			]),
			styles: styles,

			// Add Styling
			//     columnStyles: {
			//       fillColor: "cyan",
			//   0: { textAlign: 'center', fillColor: 'cyan', }, // ID column
			//   1: { textAlign: 'center', fillColor: 'cyan' }, // Patient Name column
			//   2: { textAlign: 'center', fillColor: 'cyan' }, // Doctor Name column
			//   3: { textAlign: 'center', fillColor: 'cyan' }, // Appointment Status column
			//   4: { align: 'center', fillColor: 'cyan', }, // Patient Contact column
			//   5: { textAlign: 'center', fillColor: 'cyan' }, // Appointment Date column
			// },
		});

		// doc.addPage();

		doc.save('Approved Visit Report.pdf');

		// Save PDF as blob
		// const blob = doc.output("blob");

		// Create blob URL
		// const url = URL.createObjectURL(blob);
		// setPdfUrl(url);
	};

	// Function - Download PDF File with Filter Data
	const downloadFilterData = () => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Approved Visit History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Approved Visit History', xPos, 15);

		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');

		doc.autoTable({
			startY: 20,
			head: [
				[
					// Colmn Fields Name here
					'Serial No.',
					'Patient',
					'Gender',
					'Provider',
					'Location',
					'Visit Status',
					'Visit Date',
				],
			],

			body: allVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ', ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.provider === ', ' ? '' : item?.provider,
				item?.location != null || item?.location != '' ? item?.location : '',
				item?.VisitStatus == 'A' ? 'Approved' : '',
				dayjs(item?.VisitDate).format('DD-MM-YYYY'),
			]),
			styles: styles,
		});

		// doc.addPage();

		doc.save('Approved Visit Report.pdf');

		setFilterData(allVisits);

		// Save PDF as blob
		// const blob = doc.output("blob");

		// Create blob URL
		// const url = URL.createObjectURL(blob);
		// setPdfUrl(url);
	};

	// Function - Download CSV File with All Data

	const downloadAllCSV = () => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient',
				'Gender',
				'Provider',
				'Location',
				'Visit Status',
				'Visit Date',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming apiData is an array of objects
		allVisits?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ', ' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'o' || row?.Gender == 'O'
									? 'Other'
									: '',
						row?.provider === ', ' ? '' : row?.provider,
						row?.location != null || row?.location != '' ? row?.location : '',
						row?.VisitStatus == 'A' ? 'Approved' : '',
						dayjs(row?.VisitDate).format('DD-MM-YYYY'),
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Approved Visit Report.xlsx');
	};

	// Function - Download CSV File with Filter Data

	const downloadFilterCSV = () => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient',
				'Gender',
				'Provider',
				'Location',
				'Visit Status',
				'Visit Date',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming apiData is an array of objects
		allVisits?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ', ' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'o' || row?.Gender == 'O'
									? 'Other'
									: '',
						row?.provider === ', ' ? '' : row?.provider,
						row?.location != null || row?.location != '' ? row?.location : '',
						row?.VisitStatus == 'A' ? 'Approved' : '',
						dayjs(row?.VisitDate).format('DD-MM-YYYY'),
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Approved Visit Report.xlsx');
	};

	// Function -- Download PDF Data

	const handleDownloadPdf = async () => {
		if (
			selectValue.location ||
			selectValue.provider ||
			dateValue.fromDate ||
			dateValue.toDate
		) {
			downloadFilterData(); // Direct Call throug Api Filtering in.
			// searchValuesFilter(); // Filter Pdf
		} else {
			downloadAllData(); // All Data
		}
	};

	// Function -- Download CSV Data

	const handleDownloadCSV = () => {
		if (
			selectValue.location ||
			selectValue.provider ||
			dateValue.fromDate ||
			dateValue.toDate
		) {
			downloadFilterCSV(); // Filter CSV
		} else {
			downloadAllCSV(); // All Data
		}
	};

	// Function For Getting API Locations Data

	const fetchLocations = async () => {
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				setAllLocations(response?.data);
				// console.log('Location Data: ', response?.data);
			}
		} catch (error) {
			console.error('Error fetching Locations:', error);
		}
	};

	// Function For Getting API Provider Data

	const getProviders = async () => {
		try {
			const response = await getPracticeStaff();
			if (response?.status === 200) {
				setAllProviders(response?.data);
				// console.log('Provider Data: ', response?.data);
			}
		} catch (error) {
			console.error('Error fetching Provider:', error);
		}
	};

	// Function For Getting API Visits Data
	// const getVisits = async () => {
	// 	try {
	// 		// const response = await getChargesReport();
	// 		const response = await getVisit();
	// 		if (response?.status === 200) {
	// 			setAllVisits(response?.data);
	// 			// console.log('Visits Data: ', response?.data);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching Visits:', error);
	// 	}
	// };

	//shahid  zaman function from chargelist
	const getVisitListData = async (data) => {
		try {
			// setLoading(true);
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setAllVisits(response?.data);
				// console.log('vidit data zaman', response?.data);
			} else {
				// setVisitDataList([]);
			}
			// setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			// setLoading(false);
		}
	};

	// get data Through Post method
	const filtersData = {
		practice_id: practiceID,
		in_VisitStatus: 'A',
		...(formatFromDate !== 'Invalid Date' && { in_DateFrom: formatFromDate }),
		...(formatToDate !== 'Invalid Date' && { in_DateTo: formatToDate }),
		...(selectValue.location && { in_Location: selectValue.location }),
		...(selectValue.provider && { in_Provider: selectValue.provider }),
	};

	// console.log('Filter Data => ', allVisits);

	// Fetching Api Data
	useEffect(() => {
		const fetchData = async () => {
			try {
				await fetchLocations();
				await getProviders();
				// await getVisits();
				await getVisitListData(filtersData);

				// Check if all data arrays are not empty
				if (allLocations && allProviders && allVisits) {
					setIsLoading(false); // Stop loader if all data is available
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				setIsLoading(false); // Stop loader in case of error
			}
		};

		fetchData();
	}, [selectValue, dateValue]);

	return currentPage ? (
		isLoading ? (
			// <Box
			// 	sx={{
			// 		display: 'flex',
			// 		justifyContent: 'center', // Horizontally center items
			// 		alignItems: 'center', // Vertically center items
			// 		height: '100vh',
			// 	}}
			// >
			// 	<CircularProgress size={50} />
			// </Box>

			// Maxchart Logo instead of Loader
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '80vh',
				}}
			>
				<Box
					sx={{
						opacity: 0 /* Initially hide the logo */,
						animation:
							'fadeInOut 2s linear infinite' /* Apply the fade-in and fade-out animation */,
					}}
				>
					<img className="logo" src={WebLogo} alt="Website Logo" />
				</Box>
			</Box>
		) : (
			// Content Here...
			<Paper
				elevation={1}
				sx={{
					margin: '1rem',
				}}
			>
				<Box
					sx={{
						flexGrow: 1,
						height: {
							xl: '40vh',
							lg: '30vh',
							md: '35vh',
							sm: '48vh',
							xs: '75vh',
						},
					}}
				>
					{/* padding: '0.5rem', */}
					<Box
						style={headerStyling}
						sx={{
							padding: {
								xl: '0.5rem',
								lg: '0.5rem',
								md: '0.5rem',
								sm: '0.5rem',
								xs: '0.3rem',
							},
						}}
					>
						<KeyboardBackspaceIcon
							sx={{
								fontSize: '1.5rem',
								color: 'black',
								bgcolor: 'white',
								borderRadius: '1rem',
								cursor: 'pointer',
								'&:hover': {
									bgcolor: 'black',
									color: 'white',
								},
							}}
							onClick={() => {
								setCurrentPage(false);
							}}
						/>
						<Typography
							sx={{
								fontWeight: 600,
								fontSize: {
									xl: '20px',
									lg: '20px',
									md: '20px',
									sm: '22px',
									xs: '16px',
								},
							}}
						>
							{' '}
							Approved Visit History
						</Typography>
					</Box>
					<Grid container sx={{ padding: '15px' }}>
						<Grid
							container
							item
							sx={{
								p: '15px',
								background: '#F6F6F6',
								borderRadius: '6px',
							}}
						>
							<Grid item xs={12} md={12} lg={8}>
								<Grid container spacing={2}>
									<Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												From Date
											</Typography>
											<FormControl style={borderColor}>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DatePicker
														value={dateValue.fromDate}
														name="fromDate"
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														onChange={(event) =>
															handleDateValue('fromDate', event)
														}
													/>
												</LocalizationProvider>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												To Date
											</Typography>
											<FormControl style={borderColor}>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DatePicker
														value={dateValue.toDate}
														name="toDate"
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														onChange={(event) =>
															handleDateValue('toDate', event)
														}
													/>
												</LocalizationProvider>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Location
											</Typography>

											<FormControl style={borderColor} size="small">
												<InputLabel id="demo-simple-select-label">
													Location
												</InputLabel>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													value={selectValue.location}
													label="Location"
													name="location"
													onChange={(event) => handleSelectValue(event)}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '300px',
																width: '160px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem value={''}>Clear Filter</MenuItem>
													{allLocations?.map((items, index) => {
														return (
															<MenuItem value={items?.id} key={index}>
																{items?.Name}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Provider
											</Typography>
											<FormControl style={borderColor} size="small">
												<InputLabel id="demo-simple-select-label">
													Provider
												</InputLabel>
												<Select
													labelId="demo-simple-select-label"
													id="demo-simple-select"
													label="Provider"
													name="provider"
													value={selectValue.provider}
													onChange={(event) => handleSelectValue(event)}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '300px',
																width: '160px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													<MenuItem value={''}> Clear Filter </MenuItem>
													{/*
																			 {apiData?.map((item, index) => {
																				return (
																					<MenuItem
																						key={index}
																						value={`${item?.practicestaff?.Fname}, ${item?.practicestaff?.Lname}`}
																					>
																					{`${item?.practicestaff?.Fname}, ${item?.practicestaff?.Lname}`}
																					</MenuItem>
																				);
																			})} */}
													{allProviders?.map((item, index) => {
														return (
															<MenuItem key={index} value={item?.id}>
																{item?.Lname + ', ' + item?.Fname}
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</Box>
									</Grid>
								</Grid>
							</Grid>

							<Grid item md={3} lg={2} style={grid_Button_Style}>
								<Box
									sx={{
										display: 'flex',
										marginLeft: {
											lg: '2rem',
											md: '0rem',
										},
										marginTop: {
											lg: '0rem',
											xs: '1rem',
										},
									}}
									// style={buttonStyles}
								>
									{/*<Button
																variant="contained"
																style={button_Styles1}
																onClick={() => searchValuesFilter()}
															>
																{' '}
																Search{' '}
																		</Button> */}
									<Button
										variant="contained"
										size="small"
										sx={{
											marginBottom: {
												xl: '0px',
												lg: '0px',
												md: '0px',
												sm: '0px',
												xs: '1rem',
											},
											marginLeft: {
												xl: '0px',
												lg: '0px',
												md: '0px',
												sm: '0px',
												xs: '1.5rem',
											},
											padding: '0.5rem 1.5rem',
											textTransform: 'capitalize',
											letterSpacing: '0.1rem',
											backgroundColor: '#ED2828',
										}}
										disabled={
											dateValue.fromDate ||
											dateValue.toDate ||
											selectValue.location ||
											selectValue.provider
												? false
												: true
										}
										onClick={() => {
											resetValues();
										}}
									>
										{' '}
										Reset{' '}
									</Button>
								</Box>
							</Grid>
							<Grid item md={2} lg={2} style={grid_Icon_Style}>
								<Box
									sx={{
										display: 'flex',
										gap: '1rem',
										ml: {
											lg: '0rem',
											xs: '1.5rem',
										},
									}}
								>
									<Box
										component={'img'}
										src={xlsx}
										style={csvStyle}
										onClick={() => {
											// Download CSV File Format Data
											handleDownloadCSV();
										}}
									></Box>

									<Box
										component={'img'}
										src={pdf}
										style={pdfStyle}
										onClick={() => {
											// Download Pdf File Format Data
											handleDownloadPdf();
										}}
									></Box>
								</Box>
							</Grid>
						</Grid>
					</Grid>
				</Box>
				<Divider />
				<Box
					style={filterSectionStyle}
					sx={{
						height: {
							xl: '55vh',
							lg: '55vh',
							md: '45vh',
							sm: '30vh',
							xs: '10vh',
						},
					}}
				>
					<Grid container>
						<Grid item xs={12}>
							{filterData?.length > 0 ? null : (
								<Typography
									variant="body1"
									style={textStyling}
									sx={{
										fontSize: {
											xl: '20px',
											lg: '20px',
											md: '16px',
											sm: '12px',
											xs: '12px',
										},
									}}
									disabled
								>
									Please apply filter to get reports
								</Typography>
							)}
							{/* <Typography style={textStyling}
							>
								Please apply filter to get reports
						</Typography> */}
						</Grid>
					</Grid>
				</Box>

				{pdfUrl ? (
					<div style={{ marginTop: '20px' }}>
						<iframe src={pdfUrl} width="100%" height="600px" title="PDF" />
					</div>
				) : (
					''
				)}
			</Paper>
		)
	) : (
		<PatientReport />
	);
};

export default PVS;
